export default "__VITE_ASSET__abd1a840__"